<header class="modal__header">
  @if (options.title) {
    <div class="modal__header-title">
      <h3 [ngStyle]="options.color && { color: 'black' }" id="modalLabel">{{ options.title }}</h3>
    </div>
  }
  @if (!options.disableDefaultClose) {
    <button type="button" class="button modal__button--close" (click)="close(true)">
      <i class="icon icon-ui-close--sm" [ngStyle]="options.color && { 'background-color': '#' + options.color.color }"></i>
    </button>
  }
</header>
<div class="modal__content">
  @if (options.message) {
    <div class="modal__text" [internalInnerHtml]="options.message" [userEventSource]="userEventSource"></div>
  }
</div>
@if (options.buttons.length) {
  <div class="modal__footer">
    <div
      class="button__group"
      [ngClass]="{
        'button__group--right': !options.isWideButtonGroup,
        'button__group--stretch': options.isWideButtonGroup,
        'button__group--full-width': options.isWideButtonGroup
      }"
    >
      @for (button of options.buttons; track button) {
        <button
          type="button"
          class="button"
          [ngClass]="button.buttonClass ? button.buttonClass : 'button--primary'"
          [airButtonLoading]="!!button.isLoading"
          [style.background-color]="options.color && button.isPrimary && '#' + options.color.color"
          [style.color]="options.color && !button.isPrimary && '#' + options.color.color"
          (click)="onButtonClick(button, $event)"
        >
          <span>{{ button.text }}</span>
        </button>
      }
    </div>
  </div>
}
